<template>
  <div>
    <v-data-table v-if="items.length > 0" :items="items" :headers="headers">
      <template v-slot:item="props">
        <tr>
          <td
            v-for="(header, index) in headers"
            :key="index"
            :class="
              all(props.item.id)
                ? 'red lighten-1'
                : propRequired(header.value, props.item.id)
            "
          >
            <span>{{ props.item[header.value] }}</span>
          </td>
        </tr>
      </template>
    </v-data-table>
  </div>
</template>
<script>
export default {
  props: {
    items: {
      default: () => [],
      type: Array,
    },
    properties: {
      default: () => [],
      type: Array,
    },
  },
  data: () => ({
    headers: [
      {
        text: "EmpCode",
        value: "empCode",
        sortable: false,
      },
      {
        text: "Name",
        value: "name",
        sortable: false,
      },
      {
        text: "Bank Code",
        value: "bankCode",
        sortable: false,
      },
      {
        text: "Account Type",
        value: "accountType",
        sortable: false,
      },
      {
        text: "Card Number",
        value: "cardNumber",
        sortable: false,
      },
      {
        text: "Account Number",
        value: "accountNumber",
        sortable: false,
      },
      {
        text: "Reference Number",
        value: "refNo",
        sortable: false,
      },
      {
        text: "Date Issued",
        value: "dateIssued",
        sortable: false,
      },
      {
        text: "Active",
        value: "active",
        sortable: false,
      },
      /*RLV:30Jun2022*/
      // {
      //     text: "Basic Salary Update Reason",
      //     value: "basicSalUpdateReason",
      //     sortable: false
      // }
    ],
  }),
  computed: {},
  methods: {
    propRequired(prop, index) {
      var result = this.properties.filter((item) => {
        return (
          item.property.toLowerCase() == prop.toLowerCase() &&
          item.index == index
        );
      });

      if (result.length > 0) return "red lighten-1";
      else return "";
    },
    all(index) {
      var result = this.properties.filter((item) => {
        return (
          item.property == "ALL" &&
          item.mode == "BANKINFO" &&
          item.index == index
        );
      });
      if (result.length > 0) return true;
      else false;
    },
  },
};
</script>
